import { CSSProperties } from 'react';

export const shopperOrdersIllustratedMessageStyle: CSSProperties = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center',
};
